import { render, staticRenderFns } from "./BolhaMensagem.vue?vue&type=template&id=de55f446&scoped=true&"
import script from "./BolhaMensagem.vue?vue&type=script&lang=js&"
export * from "./BolhaMensagem.vue?vue&type=script&lang=js&"
import style0 from "./BolhaMensagem.vue?vue&type=style&index=0&id=de55f446&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de55f446",
  null
  
)

export default component.exports